import React, { Component } from "react";
import Table from "../common/table/table";

class HallOfFameTable extends Component {
  columns = [
    {
      key: "user",
      label: "User",
      className: "col-8",
      content: hallOfFame => <span>{hallOfFame.user.name}</span>
    },
    {
      key: "points",
      label: "Points",
      className: "col-4 right",
      content: hallOfFame => <span>{hallOfFame.points}</span>
    }
  ];

  render() {
    const { hallOfFame } = this.props;

    if (hallOfFame.length > 0) {
      return (
        <div className="container">
          <Table columns={this.columns} data={hallOfFame} />
        </div>
      );
    }
    return null;
  }
}

export default HallOfFameTable;



// WEBPACK FOOTER //
// ./src/components/hallOfFame/hallOfFameTable.jsx